package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class MenuModel(
    val text: String,
    val route: String,
)